import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import { BaseIconProps } from './_base';
import './bars';
import './spin';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: '@gsmlg/icons',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<BaseIconProps> = ({ size, color }) =>
  html`
    <ul>
      <li>
        <icon-bars size=${size} color=${color} />
      </li>
      <li>
        <icon-spin size=${size} color=${color} />
      </li>
    </ul>
  `;

export const IconList = Template.bind({});
IconList.args = { size: 40, color: 'currentcolor' };
